

export default function Main() {
  return (
    <div>
      <div>
        <span>Carrucel</span>
      </div>
    </div>
  );
}
